import { render, staticRenderFns } from "./NavsPage.vue?vue&type=template&id=aa234c06&scoped=true&"
import script from "./NavsPage.vue?vue&type=script&lang=js&"
export * from "./NavsPage.vue?vue&type=script&lang=js&"
import style0 from "./NavsPage.vue?vue&type=style&index=0&id=aa234c06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa234c06",
  null
  
)

export default component.exports